import React, {useContext, useEffect} from 'react';
import { Image } from 'antd';
import { LoginContext } from '../../../../context/loginContext.js';

const CHomeEmpresa = () => {
const { user } = useContext(LoginContext);
  useEffect(() => {
    console.log(user)
  }, []);
  return (
    <div
      style={{
        height: 'calc(80vh - 20px)',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center',
        margin: '0',
      }}
    >
      <Image
        src="/logo-geno-gris.png"
        alt="Logo"
        preview={false}
        style={{ width: '50%', height: 'auto' }}
      />
    </div>
  );
};

export default CHomeEmpresa;